"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchDraftKey = exports.getFetchKey = exports.FETCH_DRAFT = exports.FETCH = void 0;
var FETCH = 'LEAD_FLOW_FETCH';
exports.FETCH = FETCH;
var FETCH_DRAFT = 'LEAD_FLOW_DRAFT_FETCH';
exports.FETCH_DRAFT = FETCH_DRAFT;

var getFetchKey = function getFetchKey(id) {
  return FETCH + ":" + id;
};

exports.getFetchKey = getFetchKey;

var getFetchDraftKey = function getFetchDraftKey(id) {
  return FETCH_DRAFT + ":" + id;
};

exports.getFetchDraftKey = getFetchDraftKey;